export default "__VITE_ASSET__BA_s$HcU__"